export const buildProvenance = { "commitHash": "eb12d8abdbdb68e81f4c8b16fd0a0cdf4c648ca6", "branchName": "refs/heads/release/2024.2", "buildDate": "2024-07-16T06:47:34.116Z", "version": "2024.2.9313" };
